<template>
  <ul>
    <li v-for="item in list" v-bind:class="{active: isActiveItem(item)}" v-on:click='showItem(item)'>
      <div class='name-card'>
        <h5>{{ item.get('name') }}</h5>
        <p>{{ item.get('summary') }}</p>
      </div>
    </li>
  </ul>
</template>

<script>
  import _ from 'lodash';

  export default {
    props: ['list', 'highlightedItem'],

    mounted: function(){
      // this.resizeList();
      // window.onresize = this.resizeList;
    },
    beforeDestroy: function(){
      window.onresize = null;
    },

    methods: {
      showItem: function(item){
        this.$emit('update', item);
      },
      resizeList: function(){
        var $listEl = $('.lists-table'),
            $content = $('.main-content'),
            windowHeight = $(window).height();

        $content.height(windowHeight - $content.offset().top - 20);
        $listEl.height($content.height() - $listEl.position().top)
      },
      isActiveItem: function(item){
        return item === this.highlightedItem;
      }
    }
  }
</script>
